import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const media = (): MediaQueryList | null => {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null;
  } catch {
    return null;
  }
};

const subscribe = (onChange: () => void): (() => void) => {
  const mq = media();
  if (!mq) return () => {};
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
};

/* Defaults to false when matchMedia is missing, so a UA without the API still gets the designed motion (wedge rule). */
const snapshot = (): boolean => media()?.matches ?? false;
const serverSnapshot = (): boolean => false;

/*
 * Replaces the wedge's rvReducedMotion / prepReducedMotion / acctPrefersReducedMotion one-shot reads. Subscribing
 * means a rep who flips the OS setting mid-session gets a still UI without a reload.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
